import { InvoicePlanStatus } from '@wonderschool/common-base-types';
import { ColorPaletteEnum } from '@wonderschool/common-base-ui';
import { useTranslation } from 'react-i18next';
import { BadgeWithTooltip } from '../../../Billing/BadgeWithTooltip';

/**
 * Maps invoice plan status to Badge ColorPaletteEnum
 */
const invoicePlanStatusColorMap: Record<InvoicePlanStatus, ColorPaletteEnum> = {
  [InvoicePlanStatus.PAUSED]: ColorPaletteEnum.YELLOW,
  [InvoicePlanStatus.ENDED]: ColorPaletteEnum.RED,
  [InvoicePlanStatus.SCHEDULED]: ColorPaletteEnum.PURPLE,
  [InvoicePlanStatus.ACTIVE]: ColorPaletteEnum.BLUE,
  [InvoicePlanStatus.SEND]: ColorPaletteEnum.GREEN,
};

export const mapInvoicePlanStatusToBadgeColor = (status: string): ColorPaletteEnum => {
  return invoicePlanStatusColorMap[status] || ColorPaletteEnum.GRAY;
};

export type InvoicePlanStatusLabelProps = {
  status?: InvoicePlanStatus;
};
export function InvoicePlanStatusLabel({ status }: InvoicePlanStatusLabelProps) {
  const { t } = useTranslation();

  if (!status) return null;

  // Scheduled and send statuses were not being used by the time of this change,
  // so we're not including them here although they are still in the codebase and translations.
  const filteredStatus = [InvoicePlanStatus.ACTIVE, InvoicePlanStatus.PAUSED, InvoicePlanStatus.ENDED].includes(status)
    ? status
    : InvoicePlanStatus.ACTIVE;

  const text = t(`invoicePlanStatus.${filteredStatus}`);
  const badgeColor = mapInvoicePlanStatusToBadgeColor(filteredStatus);

  return <BadgeWithTooltip label={t(text)} color={badgeColor} />;
}
